import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useTheme } from "@emotion/react";
import { useStyles } from "../../../theme/style";
import { useSelector } from "react-redux";
import { updateRapidDetailsData } from "../../../redux/slice/dataSlice";
import { useDispatch } from "react-redux";
import OktaUserMultiSelect from "../Component/Inputs/OktaUserMultiSelect";


export default function ModalRapid({
  headerMessage,
  isModalOpen,
  setIsModalOpen,
  cancelButtonText = "",
  submitButtonText = "Submit",
  handleSubmit,
  buttonState,
  isRegistering,
  userEmail
}) {
  const dispatch = useDispatch();
  const handleClose = () => setIsModalOpen(false);
  const theme = useTheme();
  const classes = useStyles(theme);
 
  const data = useSelector((state) => state.data.rapidData?.detailsJson);
  const resources = data[3]?.resources || [];
  
  const handleChangeUsers = (id, category_id, newValue) => {
    if (Array.isArray(newValue) && newValue.length > 0) {
      newValue = [newValue[newValue.length - 1]];
    }
    const updatedData = data.map((item, index) => {
      if (index === 3) {
        return {
          ...item,
          resources: item.resources.map((resource) => {
            if (resource.resource_id === id) {
              return { ...resource, value: newValue };
            }
            return resource;
          }),
        };
      }
      return item;
    });
    dispatch(updateRapidDetailsData(updatedData));
  };

  return (
    <div>
      <Modal
        open={isModalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 100,
          }}
        >
          <Box
            style={{
              backgroundColor: theme.palette.cards.background,
              padding: theme.size[30],
              borderRadius: theme.size[5],
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              color: theme.palette.cards.heading,
              minWidth: "30%",
            }}
          // onClick={handleClickOutside}
          >
            <Typography
              sx={{
                fontSize: theme.size[24],
                fontWeight: "500",
              }}
            >
              {headerMessage}
            </Typography>
            {resources.map((resource, index) => (
              <OktaUserMultiSelect
                label={resource.resource_name}
                type="multi-select-dropdown"
                value={resource.value || []}
                placeholder="Select"
                options={[]}
                isRequired={resource.isRequired || false}
                info={resource.info || resource.resource_name}
                isDisabled={false}
                prefix=""
                componentId={index}
                categoryId={resource.resource_id}
                onChange={handleChangeUsers}
                isOktaUserEnabled={true}
                disableInputSelection={false}
                loggedInUserEmail={userEmail}
              />
            ))}
            <Box
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: theme.sizeRem[0.5],
                paddingTop: theme.size[20],
              }}
            >
              {cancelButtonText && (
                <Button
                  className={classes.outlinedButton}
                  onClick={handleClose}
                >
                  {cancelButtonText}
                </Button>
              )}
              <Button
                className={classes.filledButton}
                onClick={handleSubmit}
                disabled={!buttonState.modalSubmit}
              >
                {submitButtonText}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
